import { PieChart, Pie, Cell } from 'recharts';

const percentage = 50;

const data = [
  { name: 'Yellow', value: 20, total: 10 },
  { name: 'Orange', value: 40, total: 20 },
  { name: 'Red', value: 40, total: 20 },
];

const COLORS = ['#e74c3c', '#f39c12', '#f1c40f'];

const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, value, total }: any) => {
  const radius = innerRadius + (outerRadius - innerRadius) / 2;
  const x = cx + radius * Math.cos(-midAngle * (Math.PI / 180));
  const y = cy + radius * Math.sin(-midAngle * (Math.PI / 180));

  return (
    <text x={x} y={y} fill="var(--text-primary)" textAnchor="middle" dominantBaseline="central" fontSize={14}>
      {total}
    </text>
  );
};

const AlarmsPieChart = () => {
  return (
    <div className="rounded-1 text-center" style={{ backgroundColor: 'var(--background-secondary)', height: '248px', boxShadow: '0 1px 3px rgba(0, 0, 0, 0.2)'}}>
      <div className="d-flex align-items-center justify-content-center" style={{ position: 'relative', width: '100%', height: '100%' }}>
        <PieChart width={200} height={200}>
          <Pie
            data={data}
            startAngle={180}
            endAngle={-180}
            innerRadius={70}
            outerRadius={90}
            dataKey="value"
            stroke="none"
            label={renderCustomizedLabel}
            labelLine={false}
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]}/>
            ))}
          </Pie>
        </PieChart>
        <div style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          fontSize: '32px',
          color: 'var(--text-primary)',
          fontWeight: 'bold'
        }}>
          {percentage}
        </div>
      </div>
    </div>
  );
};

export default AlarmsPieChart;
